import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from "redux";
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, } from 'redux-persist';
import localForage from 'localforage';
import quizStateReducer from './QuizSlice';


const store = configureStore({
    reducer: persistReducer(
        {
            key: 'root',
            version: 0,
            storage: localForage
        },
        combineReducers({
            quizState: quizStateReducer
        })
    ),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
        }
    })
});

export default store;